(function () {
  const ROOT_SELECTOR = '.mb-clean-pdp';
  const HELPER_SELECTOR = '[data-mb-find-phone]';
  const TESLA_SCREEN_HELP_SELECTOR = '[data-mb-tesla-screen-help]';
  const returnFocusTargets = new WeakMap();

  const hasOpenHelper = () => Boolean(document.querySelector(`${HELPER_SELECTOR}[open]`));

  const analytics = (event, detail) => {
    document.dispatchEvent(new CustomEvent(`mb:${event}`, { detail }));
    window.dataLayer?.push({ event, ...detail });
  };

  const trapHelperFocus = (helper) => {
    const dialog = helper.querySelector('.mb-find-phone__dialog');
    if (!dialog) return;
    const initialFocus = helper.querySelector('button[data-mb-find-phone-close]') || dialog;
    if (typeof trapFocus === 'function') {
      trapFocus(dialog, initialFocus);
      return;
    }
    initialFocus.focus?.({ preventScroll: true });
  };

  const releaseHelperFocus = (helper) => {
    const returnTarget = returnFocusTargets.get(helper) || helper.querySelector('.mb-find-phone__trigger');
    returnFocusTargets.delete(helper);
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(returnTarget);
      return;
    }
    returnTarget?.focus?.({ preventScroll: true });
  };

  const closeHelper = (helper) => {
    if (!helper.open) return;
    helper.open = false;
  };

  const initHelper = (helper) => {
    if (helper.dataset.mbFindPhoneInit === 'true') return;
    helper.dataset.mbFindPhoneInit = 'true';

    helper.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('mb-find-phone-open', hasOpenHelper());
      if (!helper.open) {
        releaseHelperFocus(helper);
        return;
      }
      const activeElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      returnFocusTargets.set(helper, activeElement || helper.querySelector('.mb-find-phone__trigger'));
      analytics('find_phone_opened', {});
      window.requestAnimationFrame(() => trapHelperFocus(helper));
    });

    helper.addEventListener('click', (event) => {
      const dialog = event.target.closest('.mb-find-phone__dialog');
      const trigger = event.target.closest('.mb-find-phone__trigger');
      const close = event.target.closest('[data-mb-find-phone-close]');
      if (close) {
        event.preventDefault();
        closeHelper(helper);
        return;
      }
      if (helper.open && !dialog && !trigger) {
        event.preventDefault();
        closeHelper(helper);
      }
    });
  };

  const selectedOptionValue = (group) => {
    const selected = group?.querySelector('input[data-mb-option-input]:checked, select[data-mb-option-input]');
    return String(selected?.value || '').trim();
  };

  const syncTeslaScreenHelp = (root) => {
    const helpers = root.querySelectorAll(TESLA_SCREEN_HELP_SELECTOR);
    if (!helpers.length) return;
    const modelGroup = Array.from(root.querySelectorAll('[data-mb-option-group][data-product-family="tesla"]'))
      .find((group) => /model/i.test(group.dataset.optionName || ''));
    const showHelper = /\bmodel\s*y\b/i.test(selectedOptionValue(modelGroup));

    helpers.forEach((wrapper) => {
      if (!showHelper) {
        const helper = wrapper.querySelector(HELPER_SELECTOR);
        if (helper) closeHelper(helper);
      }
      wrapper.hidden = !showHelper;
    });
  };

  const initTeslaScreenHelp = (root) => {
    if (!root.querySelector(TESLA_SCREEN_HELP_SELECTOR) || root.dataset.mbTeslaScreenHelpInit === 'true') return;
    root.dataset.mbTeslaScreenHelpInit = 'true';
    syncTeslaScreenHelp(root);
    root.addEventListener('change', (event) => {
      if (!event.target.closest('[data-mb-option-input]')) return;
      window.requestAnimationFrame(() => syncTeslaScreenHelp(root));
    });
    document.addEventListener('mb:pdp:variant-change', (event) => {
      const sectionId = String(event.detail?.sectionId || '');
      if (sectionId && sectionId !== String(root.dataset.sectionId || '')) return;
      syncTeslaScreenHelp(root);
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!hasOpenHelper()) return;
    event.preventDefault();
    document.querySelectorAll(`${HELPER_SELECTOR}[open]`).forEach(closeHelper);
  });

  const init = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      root.querySelectorAll(HELPER_SELECTOR).forEach(initHelper);
      initTeslaScreenHelp(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
